import Ticket, {RichiamaPrenotataApi} from "../../../services/ticket";
import PageDataFeed from '../../../services/page-data-feed';
import TicketData from "../../../services/ticket";
import User from "../../../services/user";
import Config from "../../../services/config";
import Observer from "./observer";
import { msg } from "@lingui/core/macro";

class TicketLogic {
    static placementCallback = null;

    /**
     * Contiene la funzione di rerender da usare per aggiornare la visualizzazione della betslip
     * @returns {*}
     */
    static betslipRenderCallback = null;
    static mainRenderCallback = null;
    static eventRenderCallback = null;

    /**
     * Contiene l'idmd5 dell'ultimo ticket trovato ad aspettare in riserva, altrimenti contiene null
     * @type {null}
     */
    static lastPendingTicket = null;
    static lastPendingTicketTime = null;
    static lastPendingTicketCheckSeconds = 30;

    /**
     * Contiene una lista delle ultime scommesse effettuate/rifiutate o in riserva del giocatore connesso
     * @type {{}}
     */
    static lastUserBets = {}

    /**
     * Permette di registrare una callback che si occupa di lanciare la renderizzazione
     * solo del componente specifico della betslip per ottimizzare le risorse del browser
     * Se non definita viene lanciato il rerender generale della pagina
     * @param callback
     */
    static registerBetslipRenderCallback(callback) {
        this.betslipRenderCallback = !!callback? ()=>callback() : null;
    }

    /**
     * Permette di registrare una callback che si occupa di lanciare la renderizzazione
     * solo del componente specifico della visualizzazione quote generale
     * Se non definita viene lanciato il rerender generale della pagina
     * @param callback
     */
    static registerMainRenderCallback(callback) {
        this.mainRenderCallback = !!callback? ()=>callback() : null;
    }

    /**
     * Permette di registrare una callback che si occupa di lanciare la renderizzazione
     * solo del componente specifico della visualizzazione quote evento singolo
     * Se non definita viene lanciato il rerender generale della pagina
     * @param callback
     */
    static registerEventRenderCallback(callback) {
        this.eventRenderCallback = !!callback? ()=>callback() : null;
    }

    /**
     * In base ai metodi registrati lancia le funzioni di rerender piu' appropriate
     * per aggiornare la visualizzazione della pagina
     */
    static rerender() {
		PageDataFeed.rerender();
        if (
            this.betslipRenderCallback === null
            || (this.mainRenderCallback === null && this.eventRenderCallback === null)
        ) {
            return;
        }

        this.betslipRenderCallback();

        if (this.mainRenderCallback !== null) {
            this.mainRenderCallback();
        }

        if (this.eventRenderCallback !== null) {
            this.eventRenderCallback();
        }
    }

    static lastBets() {
        return this.lastUserBets;
    }

    /**
     * Verifica l'esistenza di ticket in accettazione e lancia l'operazione di stampa
     * quando il ticket viene accettato
     */
    static polligPendingTickets() {
        this.fetchTicketUpdates();
        setInterval(this.fetchTicketUpdates, 999);
    }

    static fetchTicketUpdates() {
        const now =  new Date().getTime();

        if (
            TicketLogic.lastPendingTicketTime !== null
            && now - (TicketLogic.lastPendingTicketCheckSeconds*1000) < TicketLogic.lastPendingTicketTime
        ) {
            return;
        }

        TicketLogic.lastPendingTicketTime = now;

        Ticket.fetchLatestTicketsStatuses()
            .then(data => {
                TicketLogic.lastUserBets = data;
                // console.info('loop ultimi ticket', data);

                if (!!data.pending) {
                    // console.info('!!data.pending', !!data.pending, data.pending);
                    //> Ho un ticket in pending, inizio a controllare piu' velocemente per vedere quando viene gestito
                    TicketLogic.lastPendingTicket = data.pending;
                    TicketLogic.lastPendingTicketCheckSeconds = 10;

                    Ticket.fetchTicketsToConfirm().then(data => {
                        if (!data) {
                            return;
                        }
                        // console.log("Ora dovresti mostrare un popup per questi ticket: ", data);
                        Ticket.status = {type: 'accept-changes', data};
                        Observer.notify('ticket-confirm');
                        TicketLogic.rerender();
                    });
                } else {
                    // console.info('data.accepted.indexOf(this.lastPendingTicket)', data.accepted.indexOf(TicketLogic.lastPendingTicket), TicketLogic.lastPendingTicket);

                    const isAccepted = data.accepted.indexOf(TicketLogic.lastPendingTicket) !== -1;
                    const isRefused = data.refused.indexOf(TicketLogic.lastPendingTicket) !== -1;

                    //console.log('Ultime Scommesse: ', isAccepted, isRefused);

                    //> Se il ticket in pending non esisto piu' verifico se e' passato tra quelli accettati o rifiutati
                    if (isAccepted || isRefused) {
                        if (isAccepted) {
                            TicketLogic.printTicket({id: TicketLogic.lastPendingTicket, code: TicketLogic.lastPendingTicket});
                        }

                        if (isRefused) {
                            console.info('Ticket Refused!', TicketLogic.lastPendingTicket);
                            if (!!TicketLogic.placementCallback) {
                                console.info('Callback Data', {
                                    status: false,
                                    data: {type:'status', body:'ticket-rejected', code: TicketLogic.lastPendingTicket}
                                });
                                TicketLogic.placementCallback({
                                    status: false,
                                    data: {type:'status', body:'ticket-rejected', code: TicketLogic.lastPendingTicket}
                                });
                            }
                        }

                        TicketLogic.lastPendingTicket = null;
                        TicketLogic.lastPendingTicketCheckSeconds = 20;
                        //Ticket.status.type = 'done';
                        Ticket.status = false;
                        TicketLogic.rerender();
                    }

                    //> Ripristino il pollig di default
                    TicketLogic.lastPendingTicket = null;
                    TicketLogic.lastPendingTicketCheckSeconds = 20;
                }
            });
    }

    /**
     * Indica se il ticket non ha quote selezionate
     * @returns {boolean}
     */
    static isEmpty() {
        return !Ticket.hasOdds();
    }

    /**
     * Ritorna true se il ticket e' in fase di piazzamento
     * @returns {*}
     */
    static isWaitingPlacement() {
        return Ticket.isWaitingPrematch() || Ticket.isWaitingLive();
    }

    /**
     * Ritorna true se il ticket e' in fase di piazzamento specifico per il live
     * @returns {*}
     */
    static isWaitingLivePlacement() {
        return Ticket.isWaitingLive();
    }

    /**
     * Ritorna il numero di secondi mancanti al piazzamento del ticket
     * @returns {number|number}
     */
    static getLiveWaitingTimeLeft() {
        return Ticket.waitingTimeRemaining() < 0? 0 : Ticket.waitingTimeRemaining();
    }

    /**
     * Indica se il ticket e' in attesa di essere approvato dalla riserva
     * @returns {*}
     */
    static isWaitingApproval() {
        return Ticket.isPendingApproval();
    }

    /**
     * Indica se la schedina e' in uno stato sospeso in cui e' necessaria una
     * riconferma per il piazzamento da parte dell'utente
     */
    static isConfirmNeeded() {
        return Ticket.needsFlatteningConfirm() || Ticket.needsOddsChangeConfirm();
    }

    /**
     * Odd
     */
    static constainsOddsChange() {
        return Ticket.needsOddsChangeConfirm();
    }

    /**
     * Indica di giocare il ticket per conto della userid indicata come parametro
     * @param userid
     */
    static playAs(userid) {
        if (User.isAffiliate()) {
            if (!!User.data.users.filter(u => parseInt(u.idaccounts) === parseInt(userid)).length) {
                Ticket.data.playas = parseInt(userid);
                Ticket.data.autocharge = 1;
                this.rerender();
            } else if (parseInt(userid) === 0) {
                Ticket.data.playas = parseInt(userid);
                Ticket.data.autocharge = 0;
                this.rerender();
            }
        }
    }

    /**
     * Ritorna la userid per cui si sta attualmente svolgento la giocata assistita
     * @returns {number|*}
     */
    static getCurrentPlayAs() {
        return parseInt(Ticket.data.playas);
    }

    /**
     * Tenta la prenotazione del ticket
     */
    static reserve(callback) {
        if (this.canBeReserved()) {
            Ticket.statusdelivered = false;
            this.placementCallback = callback;
            Ticket.reserve();
            this.rerender();
        }
    }

    /**
     * Tenta il piazzamento del ticket
     */
    static play(callback) {
        if (this.isConfirmNeeded()) {
            Ticket.flattenAcceptFunction();
            return;
        }

        if (this.canBePlaced()) {
            Ticket.statusdelivered = false;
            this.placementCallback = callback;
            Ticket.play();
            this.rerender();

            if (Ticket.isWaitingLive()) {
                const livePlacementInterval = setInterval(() => {
                    if (!Ticket.isWaitingLive() || Ticket.waitingTimeRemaining() <= 0) {
                        clearInterval(livePlacementInterval);
                    }
                    this.rerender();
                }, 1e3);
            }
        }
    }

    /**
     * Svuota il ticket da tutte le quote selezionate
     */
    static reset() {
        Ticket.reset();
        this.rerender();
    }

    /**
     * Svuota il ticket da tutte le quote selezionate
     */
    static continue() {
        Ticket.continue();
        this.rerender();
    }

    /**
     * Ricarica la betslip del ticket prenotato identificato da reservedId
     * @param reservedId
     * @param callback
     */
    static loadReservedTicket(reservedId, callback) {
        RichiamaPrenotataApi.loadBooked(reservedId, (err,res) => !!callback && callback(err,res));
    }

    /**
     * Ricarica la betslip del ticket prenotato identificato da reservedId
     * @param reservedId
     * @param callback
     */
    static loadCashierTicket(reservedId, callback) {
        RichiamaPrenotataApi.recallBet(reservedId, (err,res) => !!callback && callback(err,res));
    }

    /**
     * Indica se il ticket e' di tipo sistema
     * @returns {boolean}
     */
    static isSystem() {
        return Ticket.isSystem();
    }

    /**
     * Indica se il ticket e' in singola
     * @returns {boolean}
     */
    static isSingle() {
        return !TicketData.isSystem() && Ticket.isSingle();
    }

    /**
     * Indica se il ticket e' in multipla
     * @returns {boolean}
     */
    static isMultiple() {
        return !Ticket.isSystem() && !Ticket.isSingle();
    }

    /**
     * Indica se il ticket puo' essere convertito a Multipla
     * @returns {*}
     */
    static canBeMultiple() {
        return Ticket.canBeMultiple();
    }

    /**
     * Indica se il ticket puo' essere convertito a Sistema
     * @returns {*}
     */
    static canBeSystem() {
        return Ticket.canBeSystem() && Ticket.countOdds() > 1;
    }

    /**
     * Indica se il ticket soddisfa i requisiti per poter essere inviato
     * @returns {*|boolean}
     */
    static canBePlaced() {
        return Ticket.canPlay() && this.getBetAmount() > 0 && (
            !this.isSystem()
            || this.getSystem().reduce((c,item) => parseFloat(item.bet)+c, 0.00) > 0
        );
    }

    /**
     * Indica se il ticket soddisfa i requisiti per poter essere prenotato
     * @returns {*|boolean}
     */
    static canBeReserved() {
        return Ticket.canReserve();
    }

    /**
     * Prova a convertire il ticket in tipo Multipla
     */
    static forceMultiple() {
        if (TicketLogic.isConfirmNeeded()) {
            return;
        }

        if (this.canBeMultiple() && this.isSystem()) {
            Ticket.beMultiple();
            Ticket.setImport(0.00);
            this.rerender();
        }
    }

    /**
     * Prova a convertire il ticket in tipo Sistema
     */
    static forceSystem() {
        if (TicketLogic.isConfirmNeeded()) {
            return;
        }

        if (this.canBeSystem() && !this.isSystem()) {
            Ticket.beSystem();
            Ticket.setImport(0.00);
            this.rerender();
        }

        //> Se il ticket e' un sistema voglio normalizzare le "fisse"
        //> rimuovendole nel caso in cui appartengano ad un evento
        //> per cui sono state selezionate anche altre quote.
        if (this.isSystem()) {
            let isUpdated = false;

            this.getOdds().map(item => {
                if (item.outcomes.length > 1) {
                    item.outcomes.map(outcome => {
                        if (!!outcome.block) {
                            Ticket.tmpToggleOddsBlock(outcome.id);
                            isUpdated = true;
                        }
                    });
                }
            });

            if (isUpdated) {
                this.rerender();
            }
        }
    }

    static hasAutoAcceptVariations() {
        return Ticket.hasAutoAcceptVariations();
    }

    static toggleAutoAcceptVariations() {
        return Ticket.toggleAutoAcceptVariations();
    }

    /**
     * Ritorna il numero di quote selezionate presenti nella betslip
     * @returns {*}
     */
    static countOdds() {
        return Ticket.countOdds();
    }

    /**
     * Ritorna un array di oggetti delle quote selezionate nella betslip
     * @returns {{outcomes, market, event, closed: boolean, order: number}[]}
     */
    static getOdds() {
        let i = 0;
        const outcomes = {};
        Ticket.mapOdds(
            ({id, odd, market, event, block, sport, category, tournament, newOdd}) => {
                const currentEvent = Ticket.getEvent(id);
                if (!outcomes[event.id]) {
                    outcomes[event.id] = {
                        outcomes: [],
                        market, // Qui non va bene per i sistemi
                        event, sport, category, tournament,
                        closed: !!odd.live && (currentEvent == null || !currentEvent.active || currentEvent.markets == 0),
                        order: ++i
                    };
                }

                outcomes[event.id].outcomes.push({
                    id, 
                    block, 
                    odds: odd, 
                    market, 
                    newOdd,
                    // Closed per le quote è true solo se hai provato a giocarle e si sono chiuse.
                    closed: odd.closed && (!newOdd || !newOdd.active)
                });
            }
        );

        if (this.countOdds() <= 1 && this.isSystem()) {
            this.forceMultiple();
        }

        return Object.values(outcomes).sort((a,b) => a.order - b.order);
    }

    /**
     * Conta il numero di quote selzionate come fixed per il sistema
     * @returns {*}
     */
    static countFixedOdds() {
        let counter = 0;
        Ticket.mapOdds(({block}) => !!block && ++counter);
        return counter;
    }

    /**
     * Ritorna il dettaglio di suddivisione del sistema
     */
    static getSystem() {
        return !!Ticket.data.system? Ticket.data.system.map(system => {
            system.preview = this.getSystemWinnings(parseInt(system.split));
            return system;
        }) : [];
    }

    /**
     * Ritorna la quota totale del ticket
     * @returns {unknown}
     */
    static getTotalOdds() {
        return Ticket.totalOdd();
    }

    /**
     * Indica se la quota prematch indicata risulta presente nella selezione del ticket o no
     * @param outcomeid
     * @return boolean
     */
    static hasPrematchOdds(outcomeid) {
        return Ticket.tmpHasPrematchOdd(outcomeid);
    }

    /**
     * Indica se la quota live indicata risulta presente nella selezione del ticket o no
     * @param outcomeid
     * @return boolean
     */
    static hasLiveOdds(outcomeid) {
        return Ticket.tmpHasLiveOdd(outcomeid);
    }

    /**
     * Accetta l'output prodotto dal componente fastbet per una singola outcome
     * e la inserisce nella betslip
     * @param fastbetoutcome
     */
    static addFastbetOdds(fastbetoutcome) {
        RichiamaPrenotataApi.toggleOddsFromQuickbet(fastbetoutcome);
        this.rerender();
    }

    /**
     * Aggiunge/Rimuove dal ticket la quota prematch indicata
     * @param outcomeid
     */
    static togglePrematchOdds(outcomeid) {
        Ticket.tmpTogglePrematchOdd(outcomeid);

        if (TicketLogic.isSystem()) {
            Ticket.setImport(0.00);
        }

        this.rerender();
    }

    /**
     * Aggiunge/Rimuove dal ticket la quota live indicata
     * @param outcomeid
     */
    static toggleLiveOdds(outcomeid) {
        Ticket.tmpToggleLiveOdd(outcomeid);
        this.rerender();
    }

    /**
     * Rimuove dal ticket una quota indipendentmente se live o prematch
     * ma accetta in input il valore id proveniente unicamente dalla chiamata a getOdds
     * @param absoluteoutcomeid
     */
    static removeOdds(absoluteoutcomeid) {
        if (TicketLogic.isConfirmNeeded()) {
            return;
        }

        Ticket.tmpToggleOdd(absoluteoutcomeid);
        this.rerender();
    }

    /**
     * Per i ticket sistema ritorna la forbice di possibile vincita del sistema
     * @returns {{minwin: null, maxwin: number}}
     */
    static getSystemPossibleWins() {
        if (!this.isSystem()) {
            return null;
        }

        let minWin = null;
        let maxWin = 0;

        TicketLogic.getSystem().map(system => {
            if (!!system.preview) {
                if (parseFloat(system.preview.minwin) < minWin || minWin === null) {
                    minWin = parseFloat(system.preview.minwin);
                }

                maxWin += parseFloat(system.preview.maxwin);
            }
        });

        return {
            minwin: minWin,
            maxwin: maxWin + parseFloat(this.getWinAmount())
            //> getWinAmount in caso di sistemi ritorna solo la porzione di vincita derivante dal bonus
        };
    }

    /**
     * Ritorna l'importo di vincita del ticket
     * @returns {number|*}
     */
    static getWinAmount() {
        return Ticket.data.win;
    }

    /**
     * In caso e' richiesta una conferma per un ticket che ha subito un appiattimento della vincita
     * questo metodo ritorna il valore del nuovo importo di vincita del ticket
     * @returns {null|*}
     */
    static getFlattenWinAmount() {
        return Ticket.flattenwin;
    }

    /**
     * Ritorna l'importo bonus associabile al ticket
     * @returns {*|number}
     */
    static getBonusAmount() {
        return !!Ticket.data.bonus? Ticket.data.bonus.amount : 0.00;
    }

    /**
     * Ritorna il dettaglio del bonus applicato
     * @returns {*}
     */
    static getBonusDetails() {
        return !!Ticket.data.bonus? Ticket.data.bonus.details : {};
    }

    /**
     * Ritorna l'importo scommesso del ticket (al lordo di betTax)
     * @returns {*}
     */
    static getBetAmount() {
        return (parseFloat(Ticket.data.bet) + parseFloat(this.getBetTaxAmount().toFixed(2))).toFixed(2);
    }

	static getBetTaxAmount() {
		return parseFloat(Ticket.data.betTax) || 0
	}

	static getWinBeforeTaxAmount() {
		return parseFloat(Ticket.data.winBeforeTax || '0') || 0
	}
	static getWinTaxAmount() {
		return this.getWinBeforeTaxAmount() - this.getWinAmount();
	}

    /**
     * Imposta una specifica quota come "Fissa" nel sistema
     * @param outcomeid
     */
    static toggleSystemFixedOdds(outcomeid) {
        if (TicketLogic.isConfirmNeeded()) {
            return;
        }

        Ticket.tmpToggleOddsBlock(outcomeid);
        this.rerender();
    }

    /**
     * Avvia la stampa del ticket
     * @param ticketdata
     */
    static printTicket(ticketdata) {
        //console.info('TicketLogic.printTicket', ticketdata);
        PageDataFeed.printTicket({
            code: ticketdata.idbets || ticketdata.id,
            id: !!ticketdata.pendingId ? ticketdata.pendingId : ticketdata.code
        });
    }

    /**
     * Imposta l'importo scommesso per il ticket
     * @param amount
     * @param split indicando uno split != 0 significa cambiare l'importo di uno specifico sviluppo di sistema
     */
    static setBetAmount(amount, split = 0) {
        if (TicketLogic.isConfirmNeeded()) {
            return;
        }

        if (User.isLogged() && User.balance() == User.bonus()) {
            if (!Config.betting['min-bonus-bet-import']) {
                Ticket.setImport(Ticket.getMinBet())
            }
        } else {
            Ticket.setImport((amount+"").replace(',', '.'), split);
        }
        this.rerender();
    }

    static maxBonusBetApplies() {
        return User.isLogged() && User.balance() == User.bonus();
    }

    /**
     * Ritorna una forbice di minimo e massimo vincita per gli sviluppi del sistema identificati dal parametri "split"
     * @param split
     * @returns {null|{minwin: string, split: number, maxwin: string}}
     */
    static getSystemWinnings(split) {
        //> Se lo sviluppo richiesto non esiste o non e' attivo esco subito
        const systemSplits = !!Ticket.data.system?
            Ticket.data.system.filter(s => parseInt(s.split) === split && s.bet > 0)
            : [];

        if (!systemSplits.length) {
            return null;
        }

        let minOdds = 1;
        let maxOdds = 1;
        const outcomesByEvents = {};
        const outcomesByMinAndMax = {min:[], max:[]};
        const system = systemSplits[0];

        Ticket.mapOdds(({event, odd, block}) => {
            if (!!block) {
                minOdds *= odd.value;
            } else {
                if (!outcomesByEvents[event.id]) {
                    outcomesByEvents[event.id] = [];
                }

                outcomesByEvents[event.id].push(odd.value);
            }
        });

        Object.values(outcomesByEvents).map(odds => {
            outcomesByMinAndMax.min.push(Math.min.apply(null, odds));
            outcomesByMinAndMax.max.push(Math.max.apply(null, odds));
        });

        outcomesByMinAndMax.min.sort((a,b) => a-b);
        outcomesByMinAndMax.max.sort((a,b) => b-a);

        //> Moltiplico i minimi e i massimi per il numero di esiti selezionato
        for (let i = 0; i < split; ++i) {
            if (!!outcomesByMinAndMax.min[i]) {
                minOdds *= outcomesByMinAndMax.min[i];
            }

            if (!!outcomesByMinAndMax.max[i]) {
                maxOdds *= outcomesByMinAndMax.max[i];
            }
        }

        return {
            split: split,
            minwin: (Math.round(system.bet * minOdds * 100) / 100).toFixed(2),
            maxwin: (Math.round(system.bet * prepare(split) * 100) / 100).toFixed(2)
        };
    }
}

//> Per qualche motivo il servizio del ticket tende a preferire il tipo sistema
//> quando la pagina viene ricaricata.
//> Preferisco invece avere la multipla quando possibile non potendo determinare
//> in precedenza quale fosse la selezione
TicketLogic.forceMultiple();

//> Monitora i ticket in riserva
TicketLogic.polligPendingTickets();

// Questo listener in realta' esiste un po' per tutto
// Quindi dobbiamo distinguere al suo interno le varie casistiche e agire di conseguenza
Ticket.subscribeSystemChanges(() => {
    if (
        (Ticket.isPlaced() || Ticket.isNotPlaced())
        && !Ticket.statusdelivered
    ) {
        if (!!TicketLogic.placementCallback) {
            TicketLogic.placementCallback({
                status: Ticket.isPlaced(),
                data: !!Ticket.status.data ? Ticket.status.data : null
            });
        }
        Ticket.statusdelivered = true;
        TicketLogic.lastPendingTicketTime = null;
        TicketLogic.fetchTicketUpdates();
        TicketLogic.rerender();
        return;
    }

    if (TicketLogic.isWaitingApproval()) {
        TicketLogic.lastPendingTicketTime = null;
        TicketLogic.fetchTicketUpdates();
    }

    if (TicketLogic.isWaitingPlacement() || TicketLogic.isWaitingApproval()) {
        TicketLogic.rerender();
        return;
    }

    //TicketLogic.forceSystem();
    TicketLogic.rerender();
});


function prepare(N) {
    const MATRICE = {};
    let mult = 1;
    let fix = 0;

    Ticket.mapOdds(({event, market, odd, block}) => {
        if (!!block) {
            mult *= odd.value;
            fix++;
        } else {
            const l = market.legatura.split('-');

            if (!(l[0] > N || l[1] < N)) {
                if (!MATRICE[event.id]) {
                    MATRICE[event.id] = {};
                }

                if (!MATRICE[event.id][market.id]) {
                    MATRICE[event.id][market.id] = {
                        legatura: [
                            l[0] - fix,
                            l[1] - fix
                        ],
                        odd: odd.value
                    };
                }

                if (MATRICE[event.id][market.id].odd < odd.value) {
                    MATRICE[event.id][market.id].odd = odd.value;
                }
            }
        }
    });

    return calcolatrice(MATRICE, Object.keys(MATRICE), 0, N, 1, N) * mult;
}

function calcolatrice(MATRICE, matches, start, end, totOdd, total) {
    if (parseInt(end) === 0) {
        return totOdd;
    }

    let tot = 0;

    for (let i = start; i <= matches.length - end; ++i) {
        Object.values(MATRICE[matches[i]]).map(item => {
            tot += calcolatrice(MATRICE, matches, i + 1, end - 1, totOdd * item.odd, total);
        });
    }

    return tot;
}

export default TicketLogic;
